import { TTranslationFunction } from '@/types'

import { TMenuSection } from '../contentFormSections/MenuForm/MenuForm'

export const formatMenuListWithDefaultSectionNames = (
	sectionList: TMenuSection[],
	t: TTranslationFunction,
) =>
	sectionList.map((section) => ({
		...section,
		name:
			section.name ||
			t('generator__content_form_section__menu__sections__default_name') +
				' ' +
				section.id,
	}))
